import {normalizeFrontendPath} from '../frontend-path';
import { Component, Inject, Optional } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import {Router} from "@angular/router";
import {Drupal7Service} from "../drupal/drupal7.service";
import {environment} from "../../environments/environment.prod";
import {ArticleResult, NodeResult} from "../drupal/resultTypes";
import {Drupal7mappingService} from "../drupal/drupal7mapping.service";
import {Article} from "../drupal/entities";

@Component({
  selector: 'app-redirect-negotiator',
  templateUrl: './redirect-negotiator.component.html',
  styleUrls: ['./redirect-negotiator.component.css']
})
export class RedirectNegotiatorComponent {
  constructor(
    private router: Router,
    private drupal7: Drupal7Service,
    private drupal7mapping: Drupal7mappingService,
    @Optional() @Inject(RESPONSE) private serverResponse: Response | null
  ) {
    let url = this.router.url;
    const normalized = normalizeFrontendPath(url);
    if (normalized !== url) {
      this.router.navigateByUrl(normalized, {replaceUrl: true});
      return;
    }
    let trimmedUrl = url.split(/[?#]/)[0].replace(/\/$/, '');
    this.drupal7.getRedirect(trimmedUrl).subscribe(response => {
      const extras = {queryParams: {...this.router.parseUrl(url).queryParams, ...(response.query || {})}, fragment: response.fragment || this.router.parseUrl(url).fragment || undefined};
      if (response.status === 'success' && response.backend === true) {
        try {
          const target = new URL(response.redirect, environment.baseUrl);
          if (target.origin !== new URL(environment.baseUrl).origin || !/^\/file\/[0-9]+$/.test(target.pathname)) { throw new Error('Invalid backend path'); }
          for (const [key, value] of Object.entries(extras.queryParams)) { target.searchParams.set(key, String(value)); }
          if (extras.fragment) { target.hash = extras.fragment; }
          const localTarget = target.pathname + target.search + target.hash;
          if (typeof window !== 'undefined') { window.location.assign(localTarget); }
          else if (this.serverResponse) { this.serverResponse.status(302).setHeader('Location', localTarget); }
        } catch (_) { this.router.navigate(['404']); }
        return;
      }
      if (response.status === 'success' && response.external) {
        try {
          const target = new URL(response.redirect);
          if (['http:', 'https:'].includes(target.protocol) && !target.username && !target.password && typeof window !== 'undefined') {
            window.location.assign(target.href);
          }
        } catch (_) { this.router.navigate(['404']); }
        return;
      }
      if (response.status == 'success' && response.path) {
        /**
         * e.g. historie/amerika-necinne-prihlizela-holocaustu-mohla-zachranit-miliony-zidu-ale-neprijala-je-65716
         * redirect to:
         * clanek/osobnosti/cyril-höschl-diky-strachu-tu-stale-jeste-jsme-ale-dojit-si-pro-prasek-na-strach-z-migrantu-nejde-30115
         */
        let args = response.path.split('/');
        if (args[0] === 'node') {
          this.drupal7.getNodeById(args[1]).subscribe((data) => {
            if (data.type == 'article') {
              let article = this.drupal7mapping.mapArticle(data);
              this.router.navigate([article.routerLink], extras);
            }
          });
        }
        else if (args[0] === 'taxonomy') {
          this.drupal7.getTaxonomyTermById(args[2]).subscribe((data) => {
            if (data.vocabulary_machine_name == 'rubriky') {
              let section = this.drupal7mapping.mapSection(data);
              this.router.navigate([section.routerLink], extras);
            }
            else if (data.vocabulary_machine_name == 'temata') {
              let tag = this.drupal7mapping.mapTag(data);
              this.router.navigate([tag.routerLink], extras);
            }
          });
        }
      }
      else if (response.status == 'success') {
        const target = new URL(response.redirect, environment.baseUrl);
        if (target.origin !== new URL(environment.baseUrl).origin) { this.router.navigate(['404']); return; }
        this.router.navigate([target.pathname], extras);
      }
      else {
        this.router.navigate(['404'])
      }
    });
  }
}
